import styled from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
  margin-left: 12px;
  margin-right: 12px;
  width: calc(100% - 24px);

  & > *:nth-child(1),
  & > *:nth-child(2) {
    flex: 1 1 0;
    min-width: 0;
  }

  & > *:nth-child(3) {
    flex: 2 1 0;
    min-width: 0;
  }

  @media (max-width: 768px) {
    & > *:nth-child(1),
    & > *:nth-child(2),
    & > *:nth-child(3) {
      flex: 1 1 100%;
    }
  }
`;

export const ContentBordered = styled.div`
  width: 100% !important;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding-top: 16px;
  border: 1px solid var(--light-2, rgba(235, 235, 240, 1));
  justify-content: center;
  height: auto;
  padding-bottom: 5px;
`;
